import styled from 'styled-components/macro';
import { ThreeBounce as Spinner } from 'better-react-spinkit';

import * as colors from 'components/common/colorConstants';

export const SectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 20px 9px 20px;
  border-top: 1px solid ${colors.lightGray21};
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: end;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: end;
`;

export const PlaceholderContainer = styled.div`
  display: inline-flex;
  height: 26px;
  border-top: 1px solid ${colors.lightGray21};
  width: 100%;
  align-items: center;
`;

PlaceholderContainer.displayName = 'PlaceholderContainer';

export const PlaceholderText = styled.div`
  font-size: 11px;
  color: ${colors.lightGray2};
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  margin-left: 55px;
`;

PlaceholderText.displayName = 'PlaceholderText';

export const LoadingDots = styled(Spinner)`
  padding-left: 9px;
  margin-bottom: 3px;
`;

export const PreviousConversationSectionRightText = styled.div`
  color: ${colors.blue1};
  font-size: 10px;
  width: 100%;
  padding-right: 5px;
  padding-top: 10px;
  margin: auto;
  justify-content: flex-end;
  width: max-content;
`;

export const PreviousConversationSectionBackIcon = styled.img`
  padding-top: 12px;
  padding-right: 10px;
`;

export const PreviousConversationSectionBackToCurrent = styled.div`
  display: flex;
  cursor: pointer;
`;

export const PreviousConversationSectionLabel = styled.div`
  margin: 5px 13px 0px 0px;
  padding-top: 5px;
  font-family: 'Roboto';
  font-style: normal;
  font-size: 11px;
  color: ${colors.lightGray2};
  width: max-content;
  white-space: nowrap;
  animation-name: fadeIn;
  animation-duration: 0.8s;
  animation-fill-mode: forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const PreviousConversationButtonGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 450px;
`;

PreviousConversationButtonGrid.displayName = 'PreviousConversationGrid';

export const PreviousConversationButton = styled.div`
  outline: none;
  width: 83px;
  height: 25px;
  border-radius: 3px;
  display: flex;
  margin-right: 7px;
  margin-top: 5px;
  cursor: pointer;
  align-items: center;
  background-color: ${(props) => (props.selected ? colors.blue1 : colors.lightGray23)};
  animation-direction: forwards;
  animation-name: fadeIn;
  animation-duration: 0.8s;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

PreviousConversationButton.displayName = 'PreviousConversationButton';

export const PreviousConversationIcon = styled.img`
  margin: auto;
  margin-right: 0px;
  position: relative;
  height: 11px;
  cursor: pointer;
`;

export const PreviousConversationButtonLabel = styled.div`
  font-size: 10px;
  text-align: right;
  margin: auto;
  line-height: 10px;
  padding-bottom: 1px;
  color: ${(props) => (props.selected ? 'white' : colors.darkGray1)};
`;

// Used in place of 'Back' text when no previous ticket button is selected
export const PlaceholderDiv = styled.div`
  width: 49px;
  height: 14px;
`;

export const CloseContainer = styled.div`
  display: block;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 14px 00px 0px 0px;

  img {
    cursor: pointer;
  }
`;
